import { spacesMessages } from 'src/features/spaces/utils/messages';
import { zoneMessages } from 'src/features/zone/utils/messages';
import { ZONE_TYPE, ZONE_CAPACITY_TYPE, VISITOR_CATEGORY_TYPE } from 'src/features/zone/utils/types';
import { BadgeOption } from 'src/registry/types/badges';
import { ICON_MAP } from 'src/utils/constants';

export const ZONE_TRANSLATION_MAP = {
    [ZONE_TYPE.REGULAR]: zoneMessages.regular,
    [ZONE_TYPE.VIP]: zoneMessages.vip,
    [ZONE_TYPE.EV]: zoneMessages.ev,
    [ZONE_TYPE.MOTORCYCLE]: zoneMessages.motorcycle,
    [ZONE_TYPE.BUFFER]: zoneMessages.buffer,
    [ZONE_TYPE.DISABLED]: zoneMessages.disabled,
};

export const zoneTypeBadgeOptions: Record<ZONE_TYPE, BadgeOption> = {
    [ZONE_TYPE.REGULAR]: {
        label: zoneMessages.regular,
        icon: ICON_MAP.CLIENT,
        theme: 'green',
    },
    [ZONE_TYPE.VIP]: {
        label: zoneMessages.vip,
        icon: ICON_MAP.CLIENT,
        theme: 'blue',
    },
    [ZONE_TYPE.EV]: {
        label: zoneMessages.ev,
        icon: ICON_MAP.EV,
        theme: 'yellow',
    },
    [ZONE_TYPE.MOTORCYCLE]: {
        label: zoneMessages.motorcycle,
        icon: ICON_MAP.MOTORCYCLE,
        theme: 'violet',
    },
    [ZONE_TYPE.DISABLED]: {
        label: spacesMessages.disabledSpace,
        icon: ICON_MAP.DISABLED,
        theme: 'orange',
    },
    [ZONE_TYPE.BUFFER]: {
        label: zoneMessages.buffer,
        icon: ICON_MAP.STATIC_SPINNER,
        theme: 'gray',
    },
};

export const ZONE_CAPACITY_TRANSLATION_MAP: Record<ZONE_CAPACITY_TYPE, { id: string; defaultMessage: string }> = {
    [ZONE_CAPACITY_TYPE.CLIENT]: zoneMessages.client,
    [ZONE_CAPACITY_TYPE.VIP]: zoneMessages.vip,
    [ZONE_CAPACITY_TYPE.RESIDENT]: zoneMessages.resident,
    [ZONE_CAPACITY_TYPE.STAFF]: zoneMessages.staff,
    [ZONE_CAPACITY_TYPE.SERVICE]: zoneMessages.service,
    [ZONE_CAPACITY_TYPE.RESERVATION]: zoneMessages.reservation,
};

export const VISITOR_CATEGORIES_TRANSLATION_MAP: Record<VISITOR_CATEGORY_TYPE, { id: string; defaultMessage: string }> =
    {
        [VISITOR_CATEGORY_TYPE.CLIENT]: zoneMessages.client,
        [VISITOR_CATEGORY_TYPE.VIP]: zoneMessages.vip,
        [VISITOR_CATEGORY_TYPE.RESIDENT]: zoneMessages.resident,
        [VISITOR_CATEGORY_TYPE.STAFF]: zoneMessages.staff,
        [VISITOR_CATEGORY_TYPE.SERVICE]: zoneMessages.service,
        [VISITOR_CATEGORY_TYPE.RESERVATION]: zoneMessages.reservation,
        [VISITOR_CATEGORY_TYPE.SUBSCRIPTION]: zoneMessages.subscription,
    };
